import EkomApi from "../api/EkomApi";
import { useFetch } from './useFetch'

export const useCountOutgoing = () => {
  return useFetch<number>(EkomApi.getCountOutgoing);
};